import Link from 'next/link'

interface Props {
  href: string
  label: string
  onClick: () => void
}

export const ShowAllCard = ({ href, label, onClick }: Props) => {
  return (
    <Link
      aria-label={`show all ${label} link`}
      href={href}
      onClick={onClick}
      className="flex-none w-[140px] min-h-[220px] flex items-center justify-center p-4 bg-gray-50 border border-dashed border-gray-300 rounded-xl text-sm text-gray-600 no-underline hover:bg-gray-100 hover:border-gray-400 transition-all duration-200"
    >
      <div className="text-center">
        <div className="text-xl mb-2 text-gray-400">+</div>
        <div className="text-sm font-medium">{label}</div>
      </div>
    </Link>
  )
}
